// src/config/planConfig.js

export const PLAN_DETAILS = {
  'STARTER': {
    name: 'STARTER',
    monthlyFee: 499,
    commissionRate: 12,
    color: '#6c757d',
    bgColor: '#f8f9fa',
    borderColor: '#6c757d',
    description: 'Best for new sellers',
    features: [
      'Up to 25 product listings',
      '1 Homepage Feature/month',
      '2 Category Features/month',
      '3 Social Media Feature/month',
      'Seller Dashboard & Analytics',
      'Access to Seasonal Campaigns'
    ]
  },
  'GROWTH': {
    name: 'GROWTH',
    monthlyFee: 1499,
    commissionRate: 9,
    color: '#007bff',
    bgColor: '#cce5ff',
    borderColor: '#007bff',
    description: 'For growing businesses',
    features: [
      'Up to 100 product listings',
      '2 Homepage Feature/month',
      '4 Category Features/month',
      '5 Social Media Features/month',
      'Seller Dashboard & Analytics',
      'Order Management',
      'Access to Seasonal Campaigns'
    ]
  },
  'PREMIUM': {
    name: 'PREMIUM',
    monthlyFee: 3999,
    commissionRate: 6,
    color: '#ffc107',
    bgColor: '#fff3cd',
    borderColor: '#ffc107',
    description: 'For established brands',
    features: [
      'Unlimited Listings',
      '4 Homepage Features/month',
      '8 Category Features/month',
      'Advanced Analytics',
      'Priority Support'
    ]
  }
};

export const PLAN_OPTIONS = [
  { value: 'STARTER', label: 'STARTER' },
  { value: 'GROWTH', label: 'GROWTH' },
  { value: 'PREMIUM', label: 'PREMIUM' }
];

export const getPlanDetails = (planKey) => {
  return PLAN_DETAILS[planKey] || PLAN_DETAILS['STARTER'];
};

export const getCommissionRate = (planKey) => {
  const plan = getPlanDetails(planKey);
  return plan.commissionRate;
};

export const getMonthlyFee = (planKey) => {
  const plan = getPlanDetails(planKey);
  return plan.monthlyFee;
};

export const getPlanColor = (planKey) => {
  const plan = getPlanDetails(planKey);
  return plan.color;
};

export const getPlanBgColor = (planKey) => {
  const plan = getPlanDetails(planKey);
  return plan.bgColor;
};